<template>
  <div class="placeholder">
    <h1>SMS Routing</h1>
    <p>Выберите раздел в боковой панели.</p>
  </div>
</template>

<style scoped>
.placeholder { padding: 24px; color: #555; }
</style>
